import { render, staticRenderFns } from "./FoodDistributionScans.vue?vue&type=template&id=b6841c9c&"
import script from "./FoodDistributionScans.vue?vue&type=script&lang=js&"
export * from "./FoodDistributionScans.vue?vue&type=script&lang=js&"
import style0 from "./FoodDistributionScans.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports